import type { FeatureFlag } from 'constants/feature-flag';

export const featureFlagsDE: Record<FeatureFlag, boolean> = {
  addressValidation: false,
  availabilityBarf: true,
  calorieCalculator: true,
  cartCrossSellPopUp: true,
  cookieBot: true,
  crossSellCheckout: true,
  crossSellPdp: true,
  dynamicUxTest: true,
  ecoOption: true,
  expressCheckout: true,
  fube: true,
  klarna: true,
  localeSwitcher: false,
  loyaltyProgram: true,
  magazin: true,
  nutritionPlan: true,
  onDemandDelivery: true,
  otp: true,
  pdexEndpoints: false,
  petProfile: true,
  preventionNeed: true,
  reauth: true,
  savingsPlan: true,
  segmentation: true,
  subCrossSell: true,
};
